import React from 'react'
import { Dot, DotProps } from 'recharts'

import { ColorVariant } from '../../../components'
import { getColor } from '../utils'
import { getSurpriseDotColor } from './utils'

type Props = DotProps & { value?: number; isActive?: boolean }

export function RedGreenDot(props: Props) {
  const { cx, cy, value, isActive, onMouseEnter, onMouseLeave } = props

  if (typeof value === 'number') {
    const size = isActive ? 6 : 5

    return (
      <Dot
        cx={cx}
        cy={cy}
        r={size}
        fill={getSurpriseDotColor(value)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        stroke={getColor(ColorVariant.default)}
        strokeWidth={1}
      />
    )
  }

  return <></>
}
